import create from "zustand";
export var useToolbarCollapseStore = create(function (set) { return ({
    collapsed: false,
    setCollapsed: function (collapsed) {
        return set(function () { return ({
            collapsed: collapsed,
        }); });
    },
}); });
